const LESSON_TYPES = {
  FETCH_LESSON_DETAILS_BEGIN: "FETCH_LESSON_DETAILS_BEGIN",
  FETCH_LESSON_DETAILS_SUCCESS: "FETCH_LESSON_DETAILS_SUCCESS",
  FETCH_LESSON_DETAILS_FAILURE: "FETCH_LESSON_DETAILS_FAILURE",

  MARK_LESSON_COMPLETE_BEGIN: "MARK_LESSON_COMPLETE_BEGIN",
  MARK_LESSON_COMPLETE_SUCCESS: "MARK_LESSON_COMPLETE_SUCCESS",
  MARK_LESSON_COMPLETE_FAILURE: "MARK_LESSON_COMPLETE_FAILURE",

  MARK_LESSON_INCOMPLETE_BEGIN: "MARK_LESSON_INCOMPLETE_BEGIN",
  MARK_LESSON_INCOMPLETE_SUCCESS: "MARK_LESSON_INCOMPLETE_SUCCESS",
  MARK_LESSON_INCOMPLETE_FAILURE: "MARK_LESSON_INCOMPLETE_FAILURE",

  ADD_LESSON_TO_CLASSROOM_BEGIN: "ADD_LESSON_TO_CLASSROOM_BEGIN",
  ADD_LESSON_TO_CLASSROOM_SUCCESS: "ADD_LESSON_TO_CLASSROOM_SUCCESS",
  ADD_LESSON_TO_CLASSROOM_FAILURE: "ADD_LESSON_TO_CLASSROOM_FAILURE",
};

export default LESSON_TYPES;
